<section class="d-flex justify-content-center align-items-center">
  <div class="py-5 px-3">
    <div class="text-right">
      <img
        (click)="activeModal.close('closed modal')"
        src="/assets/icons/close-sheet.svg"
        alt="close"
      />
    </div>
    <div class="my-3 text-center">
      <img src="/assets/icons/serving-waiter.svg" alt="call a waiter" />
    </div>

    <div class="form-section">
      <div *ngIf="source !== 'from-orders'">
        <h4 class="f-20 secondary-font-bold">Call a waiter</h4>
        <p class="mb-3 primary-font-normal">
          We have assigned a waiter to your table. Please enter your table
          number to notify them that you need service. Thank you!
        </p>
      </div>
      <div *ngIf="source === 'from-orders'">
        <h4 class="f-20 secondary-font-bold">Table Number</h4>
        <p class="mb-3 primary-font-normal">
          We have assigned a waiter to your table. Please enter your table
          number to enable find you for your order. Thank you!
        </p>
      </div>
      <app-table-form
        [buttonText]="'Call waiter'"
        (tableNumberEmitter)="collectTableNumber($event)"
      ></app-table-form>
    </div>
  </div>
</section>
